var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIpn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Main_1",
    "data-name": "Main 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-7 {\n        fill: #f57c3f;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 197.24,
    y1: 121.35,
    x2: 362.46,
    y2: 121.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#902472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#7a246a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#642462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#53245d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#472459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#402456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f2456"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 475.94,
    y1: 121.35,
    x2: 205.07,
    y2: 121.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f2456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#492962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5a3276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61367e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 410.81,
    y1: 121.42,
    x2: 118.95,
    y2: 121.42,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 259.08,
    y1: 109.38,
    x2: 3.58,
    y2: 109.38,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 127.52,
    y1: 70.28,
    x2: 239.66,
    y2: 70.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b2b74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#52286a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#47265e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#402457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f2456"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 259.08,
    y1: 159.16,
    x2: 3.58,
    y2: 159.16,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M106.81,86.83h-38.2l12.67-38.56c1.83-5.57,7.03-9.34,12.9-9.34h28.37l-15.74,47.89Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M121.17,116.39c-10.73,0-13.13,9.8-15.78,17.76-2.63,7.9-9.97,30.14-9.97,30.14l-12.45,37.63h-50.45l20.58-62.17c4.06-12.28,15.92-23.35,30.41-23.35h37.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.13,48.41l48.98-7.73,7.58,84.84,16.94-64.66c3.13-11.95,13.93-20.28,26.28-20.28h6.15c7.47,0,12.92,7.06,11.03,14.29l-38.35,146.42-49.4.85-17.26-89-23.09,88.16h-36.74l47.89-152.87Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "324.33 202.13 274.01 202.13 319.88 40.57 342.87 40.72 359.1 40.72 368 40.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.5,40.72c-10.7,0-13.09,9.78-15.74,17.71-2.63,7.88-9.94,30.06-9.94,30.06l-30.42,113.63h-45.17l38.53-138.11c4.05-12.25,15.88-23.29,30.34-23.29h32.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.74,101.61c0,34.56-28.12,62.68-62.68,62.68h-59.56s7.34-22.23,9.97-30.14c2.66-7.96,5.06-17.76,15.78-17.76h20.52v17.96l38.41-32.74s10.84-9.28,14.48-12.34c11.83-9.95,11.56-25.67,1.64-34.8,13.12,11.49,21.42,28.36,21.42,47.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M230.68,89.27c-3.64,3.06-14.48,12.34-14.48,12.34l-38.41-32.74v17.96h-50.26l15.74-47.89h47.81c15.54,0,29.78,5.68,40.74,15.09.02,0,.02.02.04.03.16.14.31.28.47.42,9.92,9.13,10.18,24.85-1.64,34.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M157.26,116.39c-10.73,0-13.13,9.8-15.78,17.76-2.63,7.9-9.97,30.14-9.97,30.14l-12.45,37.63h-50.45l20.58-62.17c4.06-12.28,15.92-23.35,30.41-23.35h37.67Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpn);
export default __webpack_public_path__ + "static/media/IPN.9d787792bdd89c91ca56a90b377a00cf.svg";
export { ForwardRef as ReactComponent };